import api from "api";
import { MediaEntity } from "models/MediaEntity";

export type GetMediaEntityRequest = { fileId: string; checklistId?: string };
export type GetMediaEntityResponse = MediaEntity;

export const getMediaEntity = async (
  fileId: string,
  checklistId?: string
): Promise<MediaEntity> => {
  const blob = await api.bin.getFile({ fileId });
  return {
    id: fileId,
    imgUrl: window.URL.createObjectURL(blob),
    mediaType: blob.type,
    checklist: checklistId,
    isLoading: false,
    compressedImage: undefined,
  };
};
